// supabaseClient.js

import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://ixjstsijqmnicqmjkzjl.supabase.co"; // Replace with your Supabase URL
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml4anN0c2lqcW1uaWNxbWprempsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjk0MDk4NjcsImV4cCI6MjA0NDk4NTg2N30.P0LBYCgVxfFL2ECpYwVkqtUJQZkIV3cmJV6calg1vDo"; // Replace with your Supabase public anon key

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    flowType: "implicit", // needed for magic-link / recovery
  },
});
